import { Skill } from "../types";

export const skills: Skill[] = [
  { name: "Flutter", icon: "/assets/tech/flutter.png", level: 95 },
  { name: "Dart", icon: "/assets/tech/dart.png", level: 95 },
  { name: "Firebase", icon: "/assets/tech/firebase.png", level: 90 },
  { name: "Node.js", icon: "/assets/tech/node.png", level: 80 },
  { name: "Python", icon: "/assets/tech/python.png", level: 75 },
  { name: "PHP", icon: "/assets/tech/php.png", level: 65 },
  { name: "React", icon: "", level: 85 },
  { name: "TypeScript", icon: "", level: 85 },
  { name: "JavaScript", icon: "", level: 90 },
  { name: "C/C++", icon: "", level: 70 },
  { name: "Git", icon: "", level: 90 },
  { name: "Docker", icon: "", level: 75 },
];
